import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { getApiBaseUrl } from "../utils/apiConfig";

const IntegrationsCallback = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      
      // Check if this is a Slack callback
      if (!code || state !== 'slack') {
        setError("Invalid callback parameters");
        setLoading(false);
        return;
      }

      try {
        const token = localStorage.getItem("token");
        const userData = localStorage.getItem("user");
        
        if (!token || !userData) {
          navigate("/login");
          return;
        }

        const user = JSON.parse(userData);
        const organizationId = user.organizations?.[0]?.organizationId;
        
        if (!organizationId) {
          setError("No organization found. Please complete onboarding first.");
          setLoading(false);
          return;
        }

        const apiUrl = getApiBaseUrl();
        
        // Call the backend to handle the Slack callback
        await axios.post(`${apiUrl}/integrations/slack/callback`,
          { 
            code, 
            organizationId
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Success! Redirect to dashboard
        navigate("/dashboard");
        
      } catch (error) {
        console.error("Error handling Slack callback:", error);
        setError("Failed to connect Slack. Please try again.");
        setLoading(false);
      }
    };

    handleCallback();
  }, [location, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-gradient-dash">
        <div className="text-center">
          <div className="inline-block align-middle w-8 h-8 border-2 border-t-2 border-t-brand border-bg-opacity rounded-full animate-spin mb-4"></div>
          <p className="text-grey-60 text-sm">Connecting your Slack workspace...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-gradient-dash">
        <div className="w-full max-w-md p-6 text-center">
          <p className="text-red-strong text-sm font-normal mb-4">{error}</p>
          <button
            onClick={() => navigate("/settings")}
            className="w-full py-3 px-4 bg-brand text-white-f text-sm font-medium tracking-wide rounded-md hover:bg-brand-dark transition"
          >
            Go to Settings
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default IntegrationsCallback;